import prismjs from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markdown';

export const highlightJson = (src) =>
  prismjs.highlight(src, prismjs.languages.json, 'json');

export const highlightMarkdown = (src) =>
  prismjs.highlight(src, prismjs.languages.markdown, 'md');
